export default __webpack_public_path__ + "static/media/6.ebb3fe8d.jpg";